import { isBetweenDates, parseBrazilianDateFormatStr } from '~/helpers/date'

// Monday to Friday
// from 09:00 to 18:00
export const isBusinessHours = () => {
  const date = new Date()
  const weekDay = date.getDay()
  const hour = date.getHours()

  return weekDay > 0 && weekDay < 6 && hour >= 9 && hour < 18
}

// Monday to Friday
// from 07:00 to 22:00
export const isExtendedBusinessHours = () => {
  const date = new Date()
  const weekDay = date.getDay()
  const hour = date.getHours()

  return weekDay > 0 && weekDay < 6 && hour >= 7 && hour < 22
}

export const isWorkingDay = () => {
  try {
    const datePairs = JSON.parse(
      import.meta.env.VITE_DISABLE_CX_FROM_DATE_PAIRS || '[]',
    ) as [string, string][]
    if (!datePairs.length) return true
    return !datePairs.some(
      ([from, to]) =>
        from &&
        to &&
        isBetweenDates(
          parseBrazilianDateFormatStr(from),
          parseBrazilianDateFormatStr(to),
        ),
    )
  } catch (e) {
    return true
  }
}
